import { useMemo } from 'react';

const useObfuscatePostId = (postId, seed) => {
    return useMemo(() => {
        if (postId == null || seed == null) return null;
        const obfuscatedId = postId ^ seed;
        return obfuscatedId.toString(16);
    }, [postId, seed]);
};

export default useObfuscatePostId;